var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isPrev)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onClick($event)}}},[_c('i',{staticClass:"fas fa-angle-left mr-2"}),_vm._v("前へ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }